import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=e52baf5c&scoped=true&"
import script from "./TaskList.vue?vue&type=script&lang=js&"
export * from "./TaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52baf5c",
  null
  
)

export default component.exports